"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorController = /** @class */ (function () {
    function InstructorController($rootScope, currentUser, store, AUTH_EVENTS, policies, SchoolsModel) {
        var _this = this;
        this.user = currentUser;
        this.school = policies.school;
        this.delinquent = false;
        SchoolsModel.getSchoolPlan(currentUser.school_id).then(function (response) {
            _this.delinquent = response.drivescout.delinquent || false;
        });
        this.dsConfig = {
            nav: {
                use_team_calendar: false,
                instructor_can_create_lessons: false,
                instructor_can_create_orders: false,
                instructor_can_create_students: false,
            },
        };
        var DS_INSTRUCTOR_NAV_CONFIG = "ds_instructor_nav_config";
        $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
            store.remove(DS_INSTRUCTOR_NAV_CONFIG);
        });
        try {
            this.dsConfig.nav.use_team_calendar = policies.policies
                .getPolicyByName("calendar")
                .getMetaValueByKey("use_team_calendar");
        }
        catch (Error) {
            this.dsConfig.nav.use_team_calendar = false;
        }
        try {
            this.dsConfig.nav.instructor_can_create_lessons = policies.policies
                .getPolicyByName("drives")
                .getMetaValueByKey("instructor_can_create_lessons");
        }
        catch (Error) {
            this.dsConfig.nav.instructor_can_create_lessons = false;
        }
        try {
            this.dsConfig.nav.instructor_can_create_orders = policies.policies
                .getPolicyByName("billing")
                .getMetaValueByKey("instructor_can_create_orders");
        }
        catch (Error) {
            this.dsConfig.nav.instructor_can_create_orders = false;
        }
        try {
            this.dsConfig.nav.instructor_can_create_students = policies.policies
                .getPolicyByName("drives")
                .getMetaValueByKey("instructor_can_create_students");
        }
        catch (Error) {
            this.dsConfig.nav.instructor_can_create_students = false;
        }
    }
    return InstructorController;
}());
InstructorController.$inject = [
    "$rootScope",
    "currentUser",
    "store",
    "AUTH_EVENTS",
    "policies",
    "SchoolsModel",
];
exports.default = InstructorController;
